import React from "react";
import { Helmet } from "react-helmet";

const MathMonsterBattleMetas = () => {
  return (
    <div>
      <Helmet>
        <title>Math Monster Battle | Fun Math Game for Kids</title>
        <meta charSet="UTF-8" />
        <meta
          name="title"
          content="Math Monster Battle | Fun Math Game for Kids | Learn with Questions"
        />
        <meta
          name="description"
          content="Join the Math Monster Battle and sharpen your skills by answering exciting math questions! Defeat the monster by solving problems correctly and advance through the rounds. A fun and engaging math game designed to improve learning and calculation speed for kids and students."
        />
        <meta
          name="keywords"
          content="Math Monster Battle, Math Game for Kids, Fun Math Questions, Learning Game, Educational Math Game, Improve Calculation Speed, Math Quiz, Math Challenge, Kids Math Practice, Mental Math, Classroom Math Game"
        />
        <meta
          property="article:published_time"
          content="2023-08-23T01:30:57+00:00"
        />
      </Helmet>
    </div>
  );
};

export default MathMonsterBattleMetas;
